import * as React from 'react';
import { Dispatch } from 'redux';
import { ClientViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as ClientNormalizers from '../normalizers/clientNormalizers';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

export class GetAllClientsRequest extends BaseApiGetRequest<
  ClientViewModel,
  EntityNormalizers.NormalizedEntityArray<ClientNormalizers.NormalizedClients>
> {
  constructor(archived: boolean, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/clients?archived=${archived}`;
    this.normalizeMethod = ClientNormalizers.normalizeClientsArray;
  }
}
